import { useState, useEffect } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import dwarfAnvil from '../assets/dwarf_anvil.svg';
import config from '../config';

const Pricing = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    document.title = 'Pricing - ä.dk URL Shortener';
    
    // Create and update meta tags
    const metaTags = {
      'description': 'Simple pricing for URL shortening. Free 7-day links or upgrade for permanent URLs and advanced features.',
      'og:title': 'Pricing - ä.dk URL Shortener',
      'og:description': 'Simple pricing for URL shortening. Free 7-day links or upgrade for permanent URLs.',
      'og:type': 'website',
      'og:url': 'https://ä.dk/pricing',
      'twitter:card': 'summary',
      'twitter:title': 'Pricing - ä.dk URL Shortener',
      'twitter:description': 'Simple pricing for URL shortening. Free 7-day links or upgrade for permanent URLs.'
    };

    // Add or update meta tags
    Object.entries(metaTags).forEach(([name, content]) => {
      let meta = document.querySelector(`meta[name="${name}"]`) || 
                 document.querySelector(`meta[property="${name}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        if (name.startsWith('og:')) {
          meta.setAttribute('property', name);
        } else {
          meta.setAttribute('name', name);
        }
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });

    // Cleanup function to remove meta tags when component unmounts
    return () => {
      Object.keys(metaTags).forEach(name => {
        const meta = document.querySelector(`meta[name="${name}"]`) || 
                    document.querySelector(`meta[property="${name}"]`);
        if (meta) {
          document.head.removeChild(meta);
        }
      });
    };
  }, []);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(`${config.apiUrl}/api/request-subscription`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to start subscription process');
      }

      setSuccess('Please check your email to verify your account and complete your subscription.');
      setEmail('');
    } catch (err) {
      console.error('Subscription error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <Navigation />
      <main className="main-content">
        <div className="container">
          <h1 className="page-title heading-2" style={{ marginBottom: '2rem' }}>Keep, analyze and maintain your <b>short</b> urls</h1>
          <div class="flex">
            <div class="col">
              <div class="card signup">
                <h2>What you get</h2>
                {error && <div className="error-message">{error}</div>}
                {success && <div className="success-message">{success}</div>}
                <div className="pricing-card">
                  <ul className="features">
                    <li>50 short URLs</li>
                    <li>Editable target URLs</li>
                    <li>Click tracking</li>
                    <li>One-click SVG QR codes</li>
                  </ul>
                  <p className="price">Only $4/month</p>
                  <form onSubmit={handleSubscribe} className="flex subscription-form">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                      className="form-input"
                      required
                    />
                    <button
                      type="submit"
                      className="button button-primary"
                      disabled={loading}
                    >
                      {loading ? 'Processing...' : 'Subscribe Now'}
                    </button>
                  </form>
                  <p style={{ textAlign: 'center' }}><small>You will recieve an email with a link to confirm your subscription.<br />Please check your spam folder if you cannot find the email.</small></p>
                </div>
              </div>
            </div>
            <div class="col">
              <img src={dwarfAnvil} style={{ maxWidth: '60%' }} alt="Illustration for subscription-page. A happy dwarf, smithing away on an URL" className="dwarf-anvil" />

            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;
